<template>
  <div id="main-content" class="add-class">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form>
        <el-row>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">Title</span>
            </el-col>
            <input class="input" v-model="attachment_data.title" type=""/>
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">File</span>
            </el-col>
            <b-form-file
              v-model="attachment_data.file"
              style="width: 60%; float: left"
              placeholder="Choose a file..."
              drop-placeholder="Drop file here..."
            ></b-form-file>
          </el-col>
        </el-row>

        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">Submit</el-button>
          <el-button style="font-size: 20px; width: 30%" type="primary">Reset</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "AddAttachment",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/attachment`, title: 'Add attachment file',
        attachment_data: {
          title: "",
          file: File,
        }
      }
    },
    methods: {
      submitAction: function () {
        let check = this.validate()
        if (check) {
          let successCallback = () => {
            this.$router.push('/attachment')
          };
          var formData = new FormData()
          for (const [key, value] of Object.entries(this.attachment_data)) {
            formData.append(key, value)
          }
          let payload = {
            successCallback,
            data: formData
          }

          this.$store.dispatch('attachmentfile/createAttachment', payload);
        }
      },
      validate: function () {
        if (this.attachment_data.title === "") {
          this.$store.commit('openNotification', {
            type: 'error',
            message: 'Please input attachment title !'
          })
          return false
        }
        return true
      }
    },
    mounted: function () {
    },
    computed: {}
  }
</script>

<style lang="scss">
  .edit-class .el-collapse-item__header,
  .add-class .el-collapse-item__header {
    font-size: 22px;
  }

  #drop-time select {
    width: 12%;
    float: left;
    margin-right: 25px;
    margin-left: 2px;
  }
</style>